import { render, staticRenderFns } from "./userAnswer.vue?vue&type=template&id=d58a6100&scoped=true&"
import script from "./userAnswer.vue?vue&type=script&lang=js&"
export * from "./userAnswer.vue?vue&type=script&lang=js&"
import style0 from "./userAnswer.vue?vue&type=style&index=0&id=d58a6100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58a6100",
  null
  
)

export default component.exports